// clearInput.ts
export function clearInput(inputRef: React.RefObject<HTMLElement | HTMLInputElement>) {
  const el = inputRef.current;
  if (!el) return;

  const input = el instanceof HTMLInputElement ? el : el.querySelector('input');
  if (!input) return;

  input.value = '';
  input.focus();

  const CLASS = 'force-focus-visible';
  input.classList.add(CLASS);

  const removeClass = () => {
    input.classList.remove(CLASS);
    input.removeEventListener('blur', removeClass);
  };

  input.addEventListener('blur', removeClass, { once: true });
}
